import axios  from "axios"
var sireUrl='semen-automation/sire'
var apprUrl='semen-automation/approval'
var collUrl='semen-automation/collection'
var strawUrl='semen-automation/straw'
var packUrl='semen-automation/pack'
var postUrl='semen-automation/postage'
export default {
    async addSire(data) {
        // ANI000014204304
        return await axios.post(sireUrl, data)
        .then(result => result.data)
        .catch(error => {return Promise.reject(error.response); });
    },
    async addApproval(data) {
        return await axios.post(apprUrl, data)
        .then(result => result.data)
        .catch(error => {return Promise.reject(error.response); });
    },
    async addCollection(data) {
        return await axios.post(collUrl, data)
        .then(result => result.data)
        .catch(error => {return Promise.reject(error.response); });
    },
    async addPostage(data) {
        return await axios.post(postUrl, data)
        .then(result => result.data)
        .catch(error => {return Promise.reject(error.response); });
    },
    async addPack(data) {
        return await axios.post(packUrl, data)
        .then(result => result.data)
        .catch(error => {return Promise.reject(error.response); });
    },
    async addStraws(data) {
        return await axios.post(strawUrl, data)
        .then(result => result.data)
        .catch(error => {return Promise.reject(error.response); });
    },
    async getSire(dataOptions, search='') {
        var url = `${sireUrl}?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
        if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async getApproval(dataOptions, search='') {
        console.log("hii",search)
        var url = `${apprUrl}?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
        if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async getCollection(dataOptions, search) {
        console.log("hii",search)
        var url = `${collUrl}?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != ''){
            url = `${url}&search=${search}`
        }
        if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async getStraw(dataOptions, search='') {
        var url = `${strawUrl}?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
        if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async getPack(dataOptions, search='') {
        var url = `${packUrl}?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
        if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async getPost(dataOptions, search='') {
        var url = `${postUrl}?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
        if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async getSinglesire(id) {
        var url = `${sireUrl}/${id}`
        return await axios.get(url)
        .then(({data}) => data.data)
        .catch( error => Promise.reject(error));
    },
    async updateSire(data) {
        return await axios.put(sireUrl, data)
        .then((result) => result.data)
        .catch( error => Promise.reject(error));
    },
    async getapprov(id) {
        var url = `${apprUrl}/${id}`
        return await axios.get(url)
        .then(({data}) => data.data)
        .catch( error => Promise.reject(error));
    },
    async updateApproval(data) {
        return await axios.put(apprUrl, data)
        .then((result) => result.data)
        .catch( error => Promise.reject(error));
    },
    async getcollect(id) {
        var url = `${collUrl}/${id}`
        return await axios.get(url)
        .then(({data}) => data.data)
        .catch( error => Promise.reject(error));
    },
    async updateCollection(data) {
        return await axios.put(collUrl, data)
        .then((result) => result.data)
        .catch( error => Promise.reject(error));
    },
    async getSinglepack(id) {
        var url = `${packUrl}/${id}`
        return await axios.get(url)
        .then(({data}) => data.data)
        .catch( error => Promise.reject(error));
    },
    async updatePack(data) {
        return await axios.put(packUrl, data)
        .then((result) => result.data)
        .catch( error => Promise.reject(error));
    },
    async getSinglestraw(id) {
        var url = `${strawUrl}/${id}`
        return await axios.get(url)
        .then(({data}) => data.data)
        .catch( error => Promise.reject(error));
    },
    async updateStraws(data) {
        return await axios.put(strawUrl, data)
        .then((result) => result.data)
        .catch( error => Promise.reject(error));
    },
    async getSinglepost(id) {
        var url = `${postUrl}/${id}`
        return await axios.get(url)
        .then(({data}) => data.data)
        .catch( error => Promise.reject(error));
    },
    async updatePostage(data) {
        return await axios.put(postUrl, data)
        .then((result) => result.data)
        .catch( error => Promise.reject(error));
    },
}